<template>
  <output-dialog
    :aspectRatio="883/1000"
    :background="require('@/assets/img/EnglishModel.jpg')"
    :fields="fields"
    :pages="pages"
    filename="EnglishModel.pdf"
    orientation="portrait"
    ref="printDlg"
    title="取引先用 登録用紙（英語）"
  />
</template>
<script>
export default {
  data() {
    return {
      fields: [
        {
          name: 'name1',
          style: {
            left: '340px',
            top: '545.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name2',
          style: {
            left: '378.11px',
            top: '545.79px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name3',
          style: {
            left: '416.73px',
            top: '545.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name4',
          style: {
            left: '456.73px',
            top: '545.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name5',
          style: {
            left: '496.73px',
            top: '545.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name6',
          style: {
            left: '536.73px',
            top: '545.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name7',
          style: {
            left: '566.73px',
            top: '545.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name8',
          style: {
            left: '606.73px',
            top: '545.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name9',
          style: {
            left: '646.73px',
            top: '545.21px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'name',
          style: {
            left: '496.73px',
            top: '575.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'showName',
          style: {
            left: '340.73px',
            top: '605.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'englishName',
          style: {
            left: '340.73px',
            top: '633.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'companyName',
          style: {
            left: '340.73px',
            top: '660.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'companyType',
          style: {
            left: '340.73px',
            top: '685.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'position',
          style: {
            left: '336.73px',
            top: '712.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'email',
          style: {
            left: '336.73px',
            top: '805.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'outsideLineNumber',
          style: {
            left: '336.73px',
            top: '743.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        },
        {
          name: 'insideLineNumber',
          style: {
            left: '336.73px',
            top: '775.08px',
            fontSize: '18px',
            lineHeight: '10px',
            transform: 'scale(0.833)'
          }
        }
      ],
      pages: []
    }
  },
  methods: {
    popup(pages) {
      this.$refs.printDlg.show = true
      this.pages = pages
    }
  }
}
</script>